import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-eighteen',
  templateUrl: './home-eighteen.component.html',
  styleUrls: ['./home-eighteen.component.scss']
})
export class HomeEighteenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
